import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'

import {
  CheckCircleFill,
  ClipboardData,
  CurrencyDollar,
  Diagram3Fill,
  FileEarmarkFill,
  Images,
  InfoCircleFill,
  PersonCircle,
  Union,
  XCircleFill,
} from 'react-bootstrap-icons'

import Navbar from '../../../components/navbar/navbar'

import { useNavigate } from 'react-router-dom'
import { CustomButton } from '../../CustomButton'
import { CustomSpinner } from '../../CustomSpinner'
import { Caracteristicas } from './components/Caracteristicas'
import { Composicao } from './components/Composicao'
import { DadosFiscais } from './components/DadosFiscais'
import { DadosICMS } from './components/DadosICMS'
import { DadosIPI } from './components/DadosIPI'
import { DadosPISCOFINS } from './components/DadosPISCOFINS'
import { Filhos } from './components/Filhos'
import { Imagens } from './components/Imagens'
import { InformacoesAdicionais } from './components/InformacoesAdicionais'
import { InformacoesGerais } from './components/InformacoesGerais'
import { Precos } from './components/Precos'

import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import {
  Center,
  Container,
  Content,
  Footer,
  Form,
  Sidebar,
  Step,
} from './styles'

export const FormProdutos = forwardRef(
  (
    {
      titlePage,
      onSubmit,
      isRequestLoading,
      isLoadingProduct,
      loadProduct,
      isEditPage,
      productToEdit,
    },
    ref,
  ) => {
    const initialState = {
      // Informações Gerais
      gerais: {
        IMG_CAPA: '',
        CODPRODUTO: '',
        SKU: '',
        SKU_PRINCIPAL: '',
        CODBARRAS: '',
        CODINTERNO: '',
        LOCALIZACAO: '',
        DESCRICAO: '',
        ID_CATEGORIA: '',
        ID_SUBCATEGORIA: '',
        MARCA: '',
        UNIDADE: 'UN',
        FORMATO: '',
        ESTOQUEMINIMO: '',
        ATIVO: 'INATIVO',
        PROD_EMBALAGEM: null,
        APTO_GERACAO: null,
        ID_CONTA: '',
      },

      // Preços
      precos: {
        PRECOCUSTO: '0',
        PRECOVENDA: '0',
        PRECOATACADO: '0',
        PRECOATACADO_P: '0',
        PRECOVAREJO_P: '0',
        COMISSAO_SOBRE_PRODUTO: '0',
      },

      // Informações Adicionais
      adicionais: {
        DESC_ITEM: '',
      },

      // Dados Fiscais
      dadosFiscais: {
        TIPO: '',
        CODNCM: '',
        CFOPNFE: '',
        CFOPNFCE: '',
        CFOPENTRADA: '',
        CFOPSAIDA: '',
      },

      // Dados ICMS / CSOSN
      icms: {
        CST: '',
        CSOSN: '',
        ORIGEM: '',
        ICMS: '',
        ICMSST: '',
        BASEICMSST: '',
        CEST: '',
      },

      // Dados IPI
      ipi: {
        CSTIPI: '',
        IPI: '',
        CODIGOSELOIPI: '',
        QTDESELOIPI: '',
        CODIGOENQIPI: '',
      },

      // Dados PIS & COFINS
      pisCofins: {
        CSTPIS: '',
        PIS: '',
        CSTCOFINS: '',
        COFINS: '',
      },

      // Características
      caracteristicas: {
        PESO_LIQUIDO: '',
        PESO_BRUTO: '',
        LARGURA: '',
        ALTURA: '',
        PROFUNDIDADE: '',
        UNIDADE_MEDIDA: '',
      },
    }
    const [product, setProduct] = useState(initialState)
    const [sidebarType, setSidebarType] = useState('max')

    const sidebarOptions = [
      {
        value: 'gerais',
        label: 'Informações Gerais',
        icon: (
          <PersonCircle
            color="white"
            size={20}
          />
        ),
      },
      isEditPage && {
        value: 'images',
        label: 'Imagens',
        icon: (
          <Images
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'precos',
        label: 'Preços',
        icon: (
          <CurrencyDollar
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'adicionais',
        label: 'Informações Adicionais',
        icon: (
          <InfoCircleFill
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'dados_fiscais',
        label: 'Dados Fiscais',
        icon: (
          <FileEarmarkFill
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'icms',
        label: 'Dados ICMS / CSOSN',
        icon: (
          <FileEarmarkFill
            color="white"
            size={20}
          />
        ),
      },

      {
        value: 'ipi',
        label: 'Dados IPI',
        icon: (
          <FileEarmarkFill
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'pis_cofins',
        label: 'Dados PIS & COFINS',
        icon: (
          <FileEarmarkFill
            color="white"
            size={20}
          />
        ),
      },
      isEditPage &&
        product.gerais.UNIDADE === 'KIT' && {
          value: 'composicao',
          label: 'Composição',
          icon: (
            <Union
              color="white"
              size={20}
            />
          ),
        },
      isEditPage && {
        value: 'filhos',
        label: 'Filhos',
        icon: (
          <Diagram3Fill
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'caracteristicas',
        label: 'Características',
        icon: (
          <ClipboardData
            color="white"
            size={20}
          />
        ),
      },
    ]
    const [activeSidebar, setActiveSidebar] = useState(sidebarOptions[0])

    const filhosRef = useRef(null)
    const composicoesRef = useRef(null)

    const navigate = useNavigate()

    useImperativeHandle(
      ref,
      () => ({
        getProduct: () => {
          return {
            product: {
              ...product.gerais,
              ...product.precos,
              ...product.adicionais,
              ...product.dadosFiscais,
              ...product.icms,
              ...product.ipi,
              ...product.pisCofins,
              ...product.caracteristicas,
            },
            children: filhosRef.current?.getChildren(),
            composicoes: composicoesRef.current?.getComposicoes(),
          }
        },
      }),
      [product],
    )

    function handleNext() {
      const sidebar = sidebarOptions.filter((sdb) => !!sdb)

      const index = sidebar.findIndex(
        (sdb) => sdb.value === activeSidebar.value,
      )

      if (index + 1 <= sidebar.length - 1) {
        setActiveSidebar(sidebar[index + 1])
      }

      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }, 500)
    }

    function handleChange(e, section) {
      const { name, value } = e.target

      setProduct((prevState) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [name]: value,
        },
      }))
    }

    useEffect(() => {
      if (productToEdit) {
        setProduct({
          gerais: {
            IMG_CAPA: productToEdit.IMG_CAPA || '',
            SKU: productToEdit.SKU || '',
            SKU_PRINCIPAL: productToEdit.SKU_PRINCIPAL || '',
            CODPRODUTO: productToEdit.CODPRODUTO || '',
            CODBARRAS: productToEdit.CODBARRAS || '',
            CODINTERNO: productToEdit.CODINTERNO || '',
            LOCALIZACAO: productToEdit.LOCALIZACAO || '',
            DESCRICAO: productToEdit.DESCRICAO || '',
            ID_CATEGORIA: productToEdit.ID_CATEGORIA || '',
            ID_SUBCATEGORIA: productToEdit.ID_SUBCATEGORIA || '',
            MARCA: productToEdit.MARCA || '',
            UNIDADE: productToEdit.UNIDADE || '',
            FORMATO: productToEdit.FORMATO || '',
            ESTOQUEMINIMO: productToEdit.ESTOQUEMINIMO || '',
            ATIVO: productToEdit.ATIVO || 'INATIVO',
            PROD_EMBALAGEM: productToEdit.PROD_EMBALAGEM || null,
            APTO_GERACAO: productToEdit.APTO_GERACAO || null,
            ID_CONTA: productToEdit.ID_CONTA || '',
          },
          precos: {
            PRECOCUSTO: productToEdit.PRECOCUSTO || 0,
            PRECOVENDA: productToEdit.PRECOVENDA || 0,
            PRECOATACADO: productToEdit.PRECOATACADO || 0,
            PRECOATACADO_P: productToEdit.PRECOATACADO_P || 0,
            PRECOVAREJO_P: productToEdit.PRECOVAREJO_P || 0,
            COMISSAO_SOBRE_PRODUTO: productToEdit.COMISSAO_SOBRE_PRODUTO || 0,
          },
          adicionais: {
            DESC_ITEM: productToEdit.DESC_ITEM || '',
          },
          dadosFiscais: {
            TIPO: productToEdit.TIPO || '',
            CODNCM: productToEdit.CODNCM || '',
            CFOPNFE: productToEdit.CFOPNFE || '',
            CFOPNFCE: productToEdit.CFOPNFCE || '',
            CFOPENTRADA: productToEdit.CFOPENTRADA || '',
            CFOPSAIDA: productToEdit.CFOPSAIDA || '',
          },
          icms: {
            CST: productToEdit.CST || '',
            CSOSN: productToEdit.CSOSN || '',
            ORIGEM: productToEdit.ORIGEM || '',
            ICMS: productToEdit.ICMS || '',
            ICMSST: productToEdit.ICMSST || '',
            BASEICMSST: productToEdit.BASEICMSST || '',
            CEST: productToEdit.CEST || '',
          },
          ipi: {
            CSTIPI: productToEdit.CSTIPI || '',
            IPI: productToEdit.IPI || '',
            CODIGOSELOIPI: productToEdit.CODIGOSELOIPI || '',
            QTDESELOIPI: productToEdit.QTDESELOIPI || '',
            CODIGOENQIPI: productToEdit.CODIGOENQIPI || '',
          },
          pisCofins: {
            CSTPIS: productToEdit.CSTPIS || '',
            PIS: productToEdit.PIS || '',
            CSTCOFINS: productToEdit.CSTCOFINS || '',
            COFINS: productToEdit.COFINS || '',
          },
          caracteristicas: {
            PESO_LIQUIDO: productToEdit.PESO_LIQUIDO || '',
            PESO_BRUTO: productToEdit.PESO_BRUTO || '',
            LARGURA: productToEdit.LARGURA || '',
            ALTURA: productToEdit.ALTURA || '',
            PROFUNDIDADE: productToEdit.PROFUNDIDADE || '',
            UNIDADE_MEDIDA: productToEdit.UNIDADE_MEDIDA || '',
          },
        })
      }
    }, [productToEdit])

    return (
      <>
        {isLoadingProduct ? (
          <Center>
            <CustomSpinner size={60} />
            <h1>Carregando produto...</h1>
          </Center>
        ) : (
          <>
            <Navbar />

            <Container
              ref={ref}
              className="mt-page"
            >
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 5,
                  }}
                >
                  <h3>{titlePage}</h3>

                  {!isEditPage && (
                    <OverlayTrigger
                      overlay={
                        <Tooltip>
                          Na criação de um produto não é possível adicionar
                          imagens, estrutura para kits, e/ou adicionar produtos
                          filhos, você será redirecionado para a tela de edição
                          ao finalizar.
                        </Tooltip>
                      }
                    >
                      <InfoCircleFill />
                    </OverlayTrigger>
                  )}
                </div>

                <Content>
                  <Sidebar
                    onDoubleClick={() =>
                      setSidebarType((prevState) =>
                        prevState === 'min' ? 'max' : 'min',
                      )
                    }
                  >
                    {sidebarOptions.map((opt) => {
                      if (!opt) {
                        return null
                      } else {
                        return (
                          <React.Fragment key={opt?.value}>
                            {sidebarType === 'min' ? (
                              <OverlayTrigger
                                overlay={<Tooltip>{opt.label}</Tooltip>}
                              >
                                <Step
                                  selected={activeSidebar.value === opt?.value}
                                  onClick={() => {
                                    setActiveSidebar(opt)

                                    window.scrollTo({
                                      top: 0,
                                      behavior: 'smooth',
                                    })
                                  }}
                                >
                                  {opt?.icon}
                                  {sidebarType !== 'min' && (
                                    <h3>{opt?.label}</h3>
                                  )}
                                </Step>
                              </OverlayTrigger>
                            ) : (
                              <>
                                {opt.value === 'gerais' ? (
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip>
                                        Dois cliques para minimizar
                                      </Tooltip>
                                    }
                                  >
                                    <Step
                                      selected={
                                        activeSidebar.value === opt?.value
                                      }
                                      onClick={() => {
                                        setActiveSidebar(opt)

                                        window.scrollTo({
                                          top: 0,
                                          behavior: 'smooth',
                                        })
                                      }}
                                    >
                                      {opt?.icon}
                                      {sidebarType !== 'min' && (
                                        <h3>{opt?.label}</h3>
                                      )}
                                    </Step>
                                  </OverlayTrigger>
                                ) : (
                                  <Step
                                    selected={
                                      activeSidebar.value === opt?.value
                                    }
                                    onClick={() => {
                                      setActiveSidebar(opt)

                                      window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth',
                                      })
                                    }}
                                  >
                                    {opt?.icon}
                                    {sidebarType !== 'min' && (
                                      <h3>{opt?.label}</h3>
                                    )}
                                  </Step>
                                )}
                              </>
                            )}
                          </React.Fragment>
                        )
                      }
                    })}
                  </Sidebar>

                  <Form>
                    <InformacoesGerais
                      isVisible={activeSidebar.value === 'gerais'}
                      product={product.gerais}
                      setProduct={setProduct}
                      handleChange={handleChange}
                      onNext={handleNext}
                      isEditPage={isEditPage}
                    />

                    <Imagens
                      isVisible={activeSidebar.value === 'images'}
                      product={{
                        CODPRODUTO: product.gerais.CODPRODUTO,
                        SKU: product.gerais.SKU,
                      }}
                      handleChange={handleChange}
                      onNext={handleNext}
                      loadProduct={loadProduct}
                    />

                    <Precos
                      isVisible={activeSidebar.value === 'precos'}
                      product={product.precos}
                      handleChange={handleChange}
                      onNext={handleNext}
                    />

                    <InformacoesAdicionais
                      isVisible={activeSidebar.value === 'adicionais'}
                      product={product.adicionais}
                      handleChange={handleChange}
                      onNext={handleNext}
                      setProduct={setProduct}
                    />

                    <DadosFiscais
                      isVisible={activeSidebar.value === 'dados_fiscais'}
                      product={product.dadosFiscais}
                      handleChange={handleChange}
                      onNext={handleNext}
                    />

                    <DadosICMS
                      isVisible={activeSidebar.value === 'icms'}
                      product={product.icms}
                      handleChange={handleChange}
                      onNext={handleNext}
                    />

                    <DadosIPI
                      isVisible={activeSidebar.value === 'ipi'}
                      product={product.ipi}
                      handleChange={handleChange}
                      onNext={handleNext}
                      setProduct={setProduct}
                    />

                    <DadosPISCOFINS
                      isVisible={activeSidebar.value === 'pis_cofins'}
                      product={product.pisCofins}
                      handleChange={handleChange}
                      onNext={handleNext}
                    />

                    <Caracteristicas
                      isVisible={activeSidebar.value === 'caracteristicas'}
                      product={product.caracteristicas}
                      handleChange={handleChange}
                      isEditPage={isEditPage}
                    />

                    <Filhos
                      ref={filhosRef}
                      isVisible={activeSidebar.value === 'filhos'}
                      product={{
                        IDPRODUTOPAI: product.gerais.CODPRODUTO,
                        SKU_PRODUTO: product.gerais.SKU,
                      }}
                      onNext={handleNext}
                    />

                    <Composicao
                      ref={composicoesRef}
                      isVisible={activeSidebar.value === 'composicao'}
                      productSku={product.gerais.SKU}
                      onNext={handleNext}
                    />
                  </Form>
                </Content>

                <Footer>
                  <CustomButton
                    color="#0d6efd"
                    title="Salvar"
                    isLoading={isRequestLoading}
                    isLoadingText="Salvando..."
                    onClick={onSubmit}
                    styles={{
                      margin: 0,
                    }}
                  >
                    <CheckCircleFill />
                  </CustomButton>

                  <CustomButton
                    color="#b21818 "
                    title="Cancelar"
                    onClick={() => navigate('/produtos')}
                    styles={{
                      margin: 0,
                    }}
                  >
                    <XCircleFill />
                  </CustomButton>
                </Footer>
              </>
            </Container>
          </>
        )}
      </>
    )
  },
)
